export default {
  apiKey: 'AIzaSyBUoTDktOWR71QHDFfmxUiLMLRusMgo5v8',
  authDomain: 'toreta-now-staging.firebaseapp.com',
  projectId: 'toreta-now-staging',
  appId: '1:984872770918:web:de5b40c9d3b87c32ff3ca7',
  measurementId: 'G-Q4TVDKGTEM',
};
